<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :append-to-body="true" :fullscreen="isMobile">
        <el-form ref="form" :model="form" label-position="top" label-width="100px" class="bookForm" :rules="rules" :show-message="false" :status-icon="true">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">

                    <el-form-item :label="translate('Firstname')" prop="firstname">
                        <el-input v-model="form.firstname"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('Lastname')" prop="lastname">
                        <el-input v-model="form.lastname"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('Company')" prop="company">
                        <el-input v-model="form.company"></el-input>
                    </el-form-item>
                   
                    <el-form-item label="Email" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('Phone')" prop="phone">
                        <oa-phone v-model="form.phone"></oa-phone>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="border-left: solid 1px #eee;border-right: solid 1px #eee;">
                    <el-form-item :label="translate('EventName')" prop="event" >
                        <el-input v-model="form.event"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('EventAddress')" prop="address">
                        <el-input v-model="form.address"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('PostalCode')" prop="postalCode">
                        <el-input v-model="form.postalCode"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('City')" prop="city">
                        <el-input v-model="form.city"></el-input>
                    </el-form-item>
                    <el-form-item :label="translate('Country')" prop="country">
                        <el-select v-model="form.country">
                            <el-option label="Allemagne" value="DE"></el-option>
                            <el-option label="Belgique" value="BE"></el-option>
                            <el-option label="Pays Bas" value="NL"></el-option>
                            <el-option label="Espagne" value="ES"></el-option>
                            <el-option label="France" value="FR"></el-option>
                            <el-option label="Grande Bretagne" value="GB"></el-option>
                            <el-option label="Italie" value="IT"></el-option>
                            <el-option label="Suisse" value="CH"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" >
                    <el-form-item label="Indoor/Outdoor" prop="inOut">
                        <el-select v-model="form.inOut" >
                            <el-option label="Indoor" :value="0"></el-option>
                            <el-option label="Outdoor" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="translate('Place')" prop="place">
                        <el-select v-model="form.place" >
                            <el-option :label="translate('Fair')" :value="0"></el-option>
                            <el-option :label="translate('Company')" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="translate('ProductTypes')" prop="products">
                        <el-checkbox-group v-model="form.products">
                            <el-checkbox v-for="p in products" :key="p.id" :label="p.id">{{p.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-form-item :label="translate('Comment')" prop="comment">
                        <el-input type="textarea" v-model="form.comment" autosize ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{translate('Cancel')}}</el-button>
            <el-button type="primary" @click="book" :disabled="loading">{{loading ? "Sending..." : translate('BookNow')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import Vue from 'vue'

    import ElementUI from 'element-ui'; // see http://element.eleme.io/#/en-US/component
    import locale from 'element-ui/lib/locale/lang/fr'

    import '../shared/phone.js';

    export default {
        props: {
            products: {}
        },
        data() {
            return {
                loading: false,
                dialogFormVisible: false,
                form: { products: [] },
                dates: {},
                box: 0,
                rules: {
                    company : [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    firstname: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    lastname: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' },
                        { type: 'email', message: 'Email incorrecte', trigger: ['blur', 'change'] }
                    ],
                    phone: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    inOut: [
                        { required: true, message: 'Obligatoire', trigger: 'change' }
                    ],
                    place: [
                        { required: true, message: 'Obligatoire', trigger: 'change' }
                    ],
                    event: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    postalCode: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    city: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],
                    country: [
                        { required: true, message: 'Obligatoire', trigger: 'blur' }
                    ],

                    products: [
                        { type: 'array', required: true, message: 'Obligatoire', trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            show(box, dates) {
                this.dialogFormVisible = true;
                this.dates = dates;
                this.box = box;
                this.form.eventStart = dates.start;
                this.form.eventEnd = dates.end;
                this.form.box = box;
                this.form.language = abp.localization.currentLanguage.name;
            },
            book() {
                var self = this;
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        abp.services.app.public.book(this.form).done(function (data) {
                            self.$emit('close');
                            self.dialogFormVisible = false;
                        }).always(function () {
                            self.loading = false;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            convertDate(inputFormat) {
                function pad(s) { return (s < 10) ? '0' + s : s; }
                var d = new Date(inputFormat);
                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            },
            translate(key) {
                return abp.localization.values.App[key];
            }
        },
        computed: {
            isMobile: function () {
                return window.matchMedia("only screen and (max-width: 760px)").matches
            },
            title() {
                return this.translate("Booking")+" Box" + " " + this.box + " " + this.translate("From") + " " + this.convertDate(this.dates.start) + " " + this.translate("To")+" " + this.convertDate(this.dates.end);
            }
        },
        created() {
            var self = this;
            //abp.services.app.dashboard.getStats().done(function (data) {
            //    self.stats = data;
            //}).always(function () {
            //    //abp.ui.clearBusy(_$app);
            //});

        },
        components: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .bookForm.el-form--label-top .el-form-item__label {
        margin: 0;
        padding: 0
    }

    .bookForm .el-form-item {
        margin-bottom: 0;
    }

    .bookForm .el-checkbox {
        margin-left: 30px;
        margin-bottom:0;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/calendar/book.vue